module.exports = __webpack_public_path__ + "static/media/Email_Img.8a8e8455.png";